"use client"

import { useEffect } from "react"
import { toast } from "react-toastify"

export const useToastNotifications = () => {
  useEffect(() => {
    const showToast = (message) => {
      toast.info(message, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        style: {
          fontFamily: "Poppins, sans-serif",
          fontSize: "1.4rem",
        },
      })
    }

    const handleContextMenu = (e) => {
      showToast("Go and Code Yaar!!")
      e.preventDefault()
      return false
    }

    const handleKeyDown = (e) => {
      if ((e.ctrlKey && e.shiftKey && ["I", "C", "J", "K", "U"].includes(e.key.toUpperCase()))) {
        showToast("It'll not open dude!!")
        e.preventDefault()
        return false
      }

      if (e.key === "F12") {
        showToast("Do you want to inspect??")
        e.preventDefault()
        return false
      }

      if (e.ctrlKey && e.key.toLowerCase() === "u") {
        showToast(" Wanna See my code??")
        e.preventDefault()
        return false
      }

      if (e.ctrlKey && e.key === "c") {
        showToast("What will you copy dude??")
        e.preventDefault()
        return false
      }

      if (e.ctrlKey && e.key === "p") {
        showToast("What will you print dude??")
        e.preventDefault()
        return false
      }


      if (e.ctrlKey && e.key === "v") {
        showToast("What will you paste dude??")
        e.preventDefault()
        return false
      }
    }

    document.addEventListener("contextmenu", handleContextMenu)
    document.addEventListener("keydown", handleKeyDown)

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu)
      document.removeEventListener("keydown", handleKeyDown)
    }
  }, [])
}
